import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from './firebase';
import type { CRMUser } from '../types';
import {
  EMPLOYEE_MENTION_DIRECTORY_ROLES,
  mapEmployeeMentionDirectoryDocs,
} from './employeeMentionDirectory';

/** Public briefing pages are outside CRMProvider — load the mention directory here. */
export function useEmployeeMentionDirectory(enabled: boolean): CRMUser[] {
  const [users, setUsers] = useState<CRMUser[]>([]);

  useEffect(() => {
    if (!enabled) {
      setUsers([]);
      return;
    }
    const unsub = onSnapshot(
      query(collection(db, 'users'), where('role', 'in', [...EMPLOYEE_MENTION_DIRECTORY_ROLES])),
      (snapshot) => {
        setUsers(mapEmployeeMentionDirectoryDocs(snapshot.docs));
      },
      (err) => {
        console.warn('[employeeMentionDirectory]', err);
        setUsers([]);
      },
    );
    return () => unsub();
  }, [enabled]);

  return users;
}
